"use client"

import styled from "@emotion/styled"
import { useTransitionRightStyles } from "./useTransitionRightStyles"
import { springEasing, transitionEase, transitionTime } from "./utils"

const transitionRightValue = "50px"

export const TransitionRight = styled.div<{
  $inView: boolean
  $delay?: number
  $isInline?: boolean
  $easing?: keyof typeof springEasing
  $height?: boolean
}>`
  width: 100%;
  height: ${(p) => (p.$height ? p.$height : "auto")};
  ${(p) => (p.$height ? "height: 100%;" : null)}
  opacity: ${(p) => (p.$inView ? 1 : 0)};
  transition: all ${transitionTime}s
    ${(p) => (p.$easing ? springEasing[p.$easing] : transitionEase)};
  transform: ${(p) => (p.$inView ? "translateX(0px)" : `translateX(100vh)`)};
  ${(p) => p.$delay && `transition-delay: ${p.$delay}s;`}
  ${(p) => p.$isInline && `display: inline;`}
`

export const TransitionRightComponent = ({
  children,
  inView,
  delay,
  easing,
}: {
  // eslint-disable-next-line no-unused-vars
  children: ((transitionStyles: any) => React.ReactNode) | null | undefined
  inView: boolean
  delay?: number
  easing?: keyof typeof springEasing
}) => {
  const transitionStyles = useTransitionRightStyles(
    inView,
    delay,
    undefined,
    easing,
  )
  // ... existing code ...

  return children ? children(transitionStyles) : null
}
